module.exports = __webpack_public_path__ + "img/firestore.7e6fc669.svg";